import { PhoneFormatter } from 'field-kit';
import { parsePhoneNumber } from 'libphonenumber-js';
// https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers#Australia
//
// Most Australian telephone numbers are 10 digits long, and can be written
// 0A BBBB BBBB or 04MM MBB BBB (for mobile telephone numbers), where 0A is the
// optional "area code" and BBBB BBBB is the subscriber number. 04MM M are
// allocated per mobile network. When the number is to be seen by an
// international audience, it is written +61 A BBBB BBBB or +61 4MM MBB BBB.
// When written for a local audience, the optional area code is omitted. The
// area code is often written within parentheses (0A) BBBB BBBB.
//
// Ten-digit non-geographic numbers beginning with 1 are written 1X0Y BBB BBB,
// where X is 8 for toll free numbers, 3 for fixed-fee numbers and 9 for premium
// services. Six digit non-geographic numbers are written 13 BB BB or 13B BBB;
// these are fixed-fee numbers. B's are sometimes written as letters.
// Occasionally, non-geographic numbers have more or fewer digits. These are
// written according to the third digit: if it is 0, the ten-digit pattern is
// used; otherwise, the six-digit pattern is.

// 13 12 34
const LOCAL = {
  delimiterMap: {
    2: ' ',
    5: ' '
  },
  maximumLength: 8
};

// 02 9876 5432
const WITH_AREA_CODE = {
  delimiterMap: {
    2: ' ',
    7: ' '
  },
  maximumLength: 12
};

// 0411 123 456
const MOBILE_WITH_AREA_CODE = {
  delimiterMap: {
    4: ' ',
    8: ' '
  },
  maximumLength: 12
};

// 1800 123 456, 1300 123 456, 1900 123 456
const NON_GEOGRAPHIC = {
  delimiterMap: {
    4: ' ',
    8: ' '
  },
  maximumLength: 12
};

// +61 2 9876 5432
const WITH_COUNTRY_CODE = {
  delimiterMap: {
    3: ' ',
    5: ' ',
    10: ' '
  },
  maximumLength: 15
};

// +61 411 123 456
const MOBILE_WITH_COUNTRY_CODE = {
  delimiterMap: {
    3: ' ',
    7: ' ',
    11: ' '
  },
  maximumLength: 15
};

// +61 1800 123 456, +61 1300 123 456, +61 1900 123 456
const NON_GEOGRAPHIC_WITH_COUNTRY_CODE = {
  delimiterMap: {
    3: ' ',
    8: ' ',
    12: ' '
  },
  maximumLength: 16
};
export default class AustralianPhoneFormatter extends PhoneFormatter {
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    if (text.startsWith('61')) {
      text = `+${text}`;
    }
    try {
      const phoneNumber = parsePhoneNumber(text, 'AU');
      text = phoneNumber.formatNational();
    } catch {
      return text;
    }

    // handles LOCAL number formatting (not supported by libphonenumber)
    if (text.startsWith('13') && text.length === 6) {
      text = `${text.slice(0, 2)} ${text.slice(2, 4)} ${text.slice(4, 6)}`;
    }
    return text;
  }
  guessFormatFromText(text) {
    if (!text) {
      super.guessFormatFromText(text);
      return;
    }
    if (text.startsWith('04')) {
      this.delimiterMap = MOBILE_WITH_AREA_CODE.delimiterMap;
      this.maximumLength = MOBILE_WITH_AREA_CODE.maximumLength;
      return;
    }
    if (text[0] === '0') {
      this.delimiterMap = WITH_AREA_CODE.delimiterMap;
      this.maximumLength = WITH_AREA_CODE.maximumLength;
      return;
    }
    if (text[0] === '1' && ['3', '8', '9'].includes(text[1]) && text.length > 2 && text[2] !== '0') {
      this.delimiterMap = LOCAL.delimiterMap;
      this.maximumLength = LOCAL.maximumLength;
      return;
    }
    if (text.startsWith('+61 4') || text.startsWith('+614')) {
      this.delimiterMap = MOBILE_WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = MOBILE_WITH_COUNTRY_CODE.maximumLength;
      return;
    }
    if (text.startsWith('+611') && ['3', '8', '9'].includes(text[4]) || text.startsWith('+61 1 ') && ['3', '8', '9'].includes(text[6]) || text.startsWith('+61 1') && ['3', '8', '9'].includes(text[5])) {
      this.delimiterMap = NON_GEOGRAPHIC_WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = NON_GEOGRAPHIC_WITH_COUNTRY_CODE.maximumLength;
      return;
    }
    if (text[0] === '+') {
      this.delimiterMap = WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = WITH_COUNTRY_CODE.maximumLength;
      return;
    }
    this.delimiterMap = NON_GEOGRAPHIC.delimiterMap;
    this.maximumLength = NON_GEOGRAPHIC.maximumLength;
  }
}